const heights = [];

for (let feet = 3; feet <= 7; feet++) {
    for (let inches = 0; inches <= 11; inches++) {
        const totalInches = feet * 12 + inches;
        const cm = Math.round(totalInches * 2.54);

        heights.push({
            name: `${feet}' ${inches}''`,
            value: `${feet}' ${inches}''`,
            cm_value: cm.toString()
        });
    }
}
export default heights;
